import script from "./BenefitTab.vue?vue&type=script&setup=true&lang=js"
export * from "./BenefitTab.vue?vue&type=script&setup=true&lang=js"

import "./BenefitTab.vue?vue&type=style&index=0&id=671ff22c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-671ff22c"]])

export default __exports__